<template>
  <div class="term">
    <div class="term__title">
      <div class="label">{{ label }}</div>
      <div class="term__value">
        <span v-if="!editable" class="days">
          <b>{{ currentTerm }}</b>
          <span>{{ $t('calculator.days') }}</span>
        </span>
      </div>
    </div>

    <template v-if="editable">
      <div class="term__elements">
        <button
          v-for="{term, active} in termList"
          :key="term"
          v-qa="`term_btn_${term}`"
          :class="['item-group', { 'active': active }]"
          @click="setTerm(term)">
          <span class="item-group__number">{{ term }}</span>
          <span>{{ $t('calculator.days') }}</span>
        </button>
      </div>
      <span class="select-term-title">{{ $t('calculator.term-select-warning') }}</span>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: Number, required: true },
    editable: { type: Boolean, default: true },
    label: { type: String, default: '' },
  },
  data() {
    return {
      currentTerm: this.value,
    };
  },

  computed: {
    termList() {
      return [30, 45].map(term => ({
        term,
        active: term === this.currentTerm,
      }));
    },
  },

  methods: {
    setTerm(term) {
      this.currentTerm = term;
      this.$emit('input', term);
    },
  },
};
</script>

<style scoped lang="scss">
.term {
  margin-bottom: 5px;

  &__title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  }

  &__elements {
    display: flex;
    gap: 20px;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  }
}

.item-group {
  width: 100%;
  border: 2px solid map-get($colors, border);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0.5rem 1rem;
  color: map-get($colors, placeholder);
  background: transparent;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &__number {
    font-size: 1.5rem;
    font-weight: 600;
  }

  &:hover {
    @extend .active;
  }
}

.label {
  font-weight: 600;
}

.days {
  font-size: 20px;
}

.active {
  border: 2px solid map-get($colors, secondary);
  color: map-get($colors, text);
  font-weight: 600;
}

.select-term-title {
  display: block;
}
</style>
